import { formatResolution } from '../../../../../../formatters/resolution/resolution-formatter.js';
import {
  FormatterWithPrecision,
  type TimeFrameFormatter,
} from '../../../../../core/types/formatter.js';
import { XYAccessorDataTypes } from '../../../../types/xy-chart.js';
import {
  isCategoricalTooltip,
  isNumericalToolTip,
  isTimeTooltip,
} from '../../../../utils/type-guards.js';

export function useDotSeriesTooltipHeaderContent(
  [v0, v1]: [v0: XYAccessorDataTypes, v1?: XYAccessorDataTypes],
  formatter?: FormatterWithPrecision | TimeFrameFormatter,
) {
  let text = '';
  let duration: string | undefined;

  const args = {
    formatter,
    v0,
    v1,
  };

  if (isCategoricalTooltip(args)) {
    text = args.v0;
  }

  if (isNumericalToolTip(args)) {
    text = `${args.formatter(args.v0)}`;
  }

  if (isTimeTooltip(args)) {
    text = `${args.formatter(args.v0, args.v1)}`;
    duration = formatResolution(args.v0, args.v1);
  }

  return { duration, text };
}
